import React from 'react';
import isNil from 'lodash/isNil';
import { useFieldValue } from '@atlassian/jira-issue-field-base';
import { PRIORITY_TYPE } from '@atlassian/jira-platform-field-config';
import {
	// PriorityFieldWrapper,
	StaticPriorityFieldWrapper,
} from '../../card/card-contents/priority-field';
import PriorityFieldStatic from '../../card/card-contents/priority-field/priority-field-static';

export const PriorityLite = ({
	issueKey,
	shouldRenderPriorityColumn,
}: {
	shouldRenderPriorityColumn: boolean;
	issueKey: string;
}) => {
	const [priorityFieldValue] = useFieldValue({
		issueKey,
		fieldKey: PRIORITY_TYPE,
	});

	// Matching src/packages/software/backlog/src/view/card-list/card/card-contents/priority-field/index.tsx
	if (!shouldRenderPriorityColumn) return null;

	const hasPriority =
		!isNil(priorityFieldValue) &&
		!isNil(priorityFieldValue.name) &&
		!isNil(priorityFieldValue.iconUrl);

	const priorityFieldStatic = (
		<StaticPriorityFieldWrapper shouldRenderColumn={shouldRenderPriorityColumn}>
			{hasPriority ? (
				<PriorityFieldStatic name={priorityFieldValue.name} iconUrl={priorityFieldValue.iconUrl} />
			) : null}
		</StaticPriorityFieldWrapper>
	);

	return priorityFieldStatic;
};
